module.exports = __webpack_public_path__ + "static/media/corp_bonds.a24103ac.png";